<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="relative mx-auto flex min-h-screen w-full flex-col bg-background-tint">
    <RouterView />
  </div>
</template>
